import { SxProps } from '@mui/material';

export const mainBox: SxProps = {
  '@media screen and (min-width: 320px) and (max-width: 767px)': {
    width: '100%',
    padding: '0 16px',
  },
  '@media screen and (min-width: 1200px)': {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 15px',
    boxSizing: 'border-box',
  },
};

export const header: SxProps = {
  pt: '50px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  '@media screen and (max-height: 864px)': {
    pt: '24px',
  },
};

export const bgImage: SxProps = {
  // backgroundImage: 'url("/images/bg.png")',
  backgroundColor: '#F6F6F6',
  position: 'absolute',
  top: 0,
  width: '100%',
  height: '100%',
  zIndex: '-1',
  left: 0,
  // backgroundRepeat: 'no-repeat',
  // backgroundPosition: 'center',
  // backgroundSize: 'cover',

  '@media screen and (min-width: 320px) and (max-width: 767px)': {
    display: 'none',
  },
};

export const footer: SxProps = {
  display: 'flex',
  justifyContent: 'flex-end',

  '@media screen and (min-width: 320px) and (max-width: 767px)': {
    display: 'none',
  },
};
